import React,{useState,useEffect} from 'react';
import {connect} from "react-redux";
import {useNavigate} from 'react-router-dom';

const Main = ({mount,login}) => {

    const navigate = useNavigate();

    useEffect(() => {
        if(mount.status){
            if(login.isLogin){
                setTimeout(() => {
                },1000)
            }
            else{
                navigate("/login");
            }
        }
    }, [login,mount]);

    return(
        <div className="vh-100">
            <div className="container h-100" style={{maxWidth:'360px'}}>
                <div className="row align-items-center justify-contain-center" style={{height:'60%'}}>
                    <div className="col-xl-12">
                         <img width="300" src="/nanduledger.png" />
                    </div>
                </div>
            </div>
        </div>
    );

}

const initMapStateToProps = state => ({
    login: state.auth,
    mount: state.mount,
})

export default connect(initMapStateToProps) (Main)
